import { render, staticRenderFns } from "./blockView.vue?vue&type=template&id=0e93184c&"
import script from "./blockView.vue?vue&type=script&lang=js&"
export * from "./blockView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports